<template>
  <v-card class="col-md-12" :loading="loading">
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            شناسه
          </th>
          <th class="text-center">
            لینک آگهی
          </th>
          <th class="text-center">
            نوع آگهی
          </th>
          <th class="text-center">
            وضعیت ارسالی
          </th>
          <th class="text-center">
            تاریخ ساخت
          </th>
          <th class="text-center">
            دفعات تکرار
          </th>
          <th class="text-center">
            مدیریت
          </th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="item in data" :key="item.id">
          <td class="text-center">{{ item.id }}</td>
          <td class="text-center">{{ item.payload.title }}</td>
          <td class="text-center">{{ item.type }}</td>
          <td class="text-center">{{ item.status ? 'فعال' : 'غیرفعال' }}</td>
          <td class="text-center">{{ jalalian(item.created_at) }}</td>
          <td class="text-center">{{ item.repeated }}</td>
          <td class="text-center">
            <div>
              <v-btn @click="controlJob(item.id)" v-if="item.status" color="success" small>غیرفعال کردن</v-btn>
              <v-btn @click="controlJob(item.id)" v-if="!item.status" color="error" small>فعال کردن</v-btn>
              <v-btn @click="deleteJob(item.id)"  color="error" class="mx-2" icon small><v-icon>mdi-delete</v-icon></v-btn>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import {RobotAxios} from "../../../main";

export default {
  name: "smartList",
  data() {
    return {
      loading: false,
      data: {},
    }
  },
  methods: {
    getData(query = this.tableProps) {
      this.loading = true;

      RobotAxios.get('/api/smart/', {
        params: query
      }).then(response => {
        this.data = response.data.data;
      }).catch(reason => {
        this.$modal.error('خطا', 'در دریافت اطلاعات با خطا مواجه‌ شدیم.');

      }).finally(() => {
        this.loading = false;
      });
    },
    controlJob(id) {
      this.$modal.yesNo('آیا از انجام این عملیات اطمینان دارید؟').then((value) => {
        if (value === true) {
          RobotAxios.put(`/api/smart/${id}`).then(() => {
            this.$toast.success('باموفقیت درخواست شما انجام شد.');
          }).catch(() => {
            this.$toast.error('خطا!')
          })
        } else return false;
      })

    },
    deleteJob(id) {
      this.$modal.yesNo('آیا از حذف این اطلاعات اطمینان دارید؟').then((value) => {
        if (value === true) {
          RobotAxios.delete(`/api/smart/${id}`).then(() => {
            this.$toast.success('باموفقیت درخواست شما انجام شد.');
            this.getData()
          }).catch(() => {
            this.$toast.error('خطا!')
          })
        } else return false;
      })

    },
  },
  mounted() {
    this.getData()
  }

}
</script>

<style scoped>

</style>
